<script lang='jsx'>
import CPopupBuilder from './editor/nodes/CPopupBuilder.vue'
export default {
  name: 'PopUpRenderer',
  components: { CPopupBuilder },
  props: {
    popupPath: {
      type: String,
      required: true,
    },
    pageEngineWrapperClass: {
      type: Array,
      required: true,
    },
    isPopupOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {},
  render (h) {
    const parentClassWrapperData = {
      class: this.isPopupOpen ? [this.pageEngineWrapperClass, 'page-engine-wrapper-cpopup', 'typography'] : ''
    }
    return (
      <div {...parentClassWrapperData}>
        {h('CPopupBuilder', {
          props: {
            ['.path']: this.popupPath,
          },
        })}
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
.page-engine-wrapper-cpopup{
  background: #06061666;
}
</style>
